import type { ProductPageViewModel } from 'autogen/swagger/all';
import BasicChips from 'components/chat/COMAI/components/BasicChips';

export interface ProductChipsProps {
    chips?: ProductPageViewModel['chips'];
    productId: number;
}

export default function ProductChips({ chips, productId }: ProductChipsProps) {
    const chipsToDisplay = chips?.chips;

    if (!chipsToDisplay) return null;

    return <BasicChips chips={chipsToDisplay} context={{ productCardId: productId }} showAIIcon />;
}
